import React from 'react';
import { Position } from '../../Modules/Base/Enums/Position.enum';
import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './Buttons.module.scss';
import { joinClasses } from '../../Utils/className.util';

interface AddButtonProps {
	onClick: () => void;
	title?: string;
	iconPosition?: Position;
}
export default function AddButton(props: AddButtonProps) {
	const {
		onClick,
		title = 'base.addItem',
		iconPosition = Position.RIGHT,
	} = props;

	const handlePress = () => {
		onClick && onClick();
	};

	return (
		<div className={joinClasses([styles.actionButton, iconPosition === Position.RIGHT ? styles.iconRight : ''])} onClick={handlePress}>
			<img
				className={styles.icon}
				src={'/dist/icons/add-new.svg'}
				alt={'plus icon'}
			/>
			<Text
				className={styles.title}
				tx={title}
				inline={true}
				firstUpper={true}
			/>
		</div>
	);
}
